import { Outlet } from 'react-router';
import { isUserAdmin } from '@/utils/auth-helpers';
import { useUserState } from '@/state/user.state';
import { lazy } from 'react';

const PageNotFound = lazy(() => import('@/pages/errors/4xx-error'));

export function AdminGuard() {
    const user = useUserState();
    
    const isAdmin = isUserAdmin(user.role);
    
    if (!isAdmin) {
        return (
            <PageNotFound/>
        );
    }
    
    return (
        <Outlet/>
    );
}